import React from 'react';

export interface ModalContextValue {
  onClose: () => void;
}

export const ModalContext = React.createContext<ModalContextValue>({
  onClose: () => undefined,
});

export function ModalContextProvider(props: {
  children: React.ReactNode;
  onClose: () => void;
}): JSX.Element {
  return (
    <ModalContext.Provider value={{onClose: props.onClose}}>
      {props.children}
    </ModalContext.Provider>
  );
}

export default function useModalContext(): ModalContextValue {
  return React.useContext(ModalContext);
}
